// extracted by mini-css-extract-plugin
module.exports = {"Logo":"_1z_7YGFtl2_cqdoNbtHBbs"};